import styled from 'styled-components';

export const Padding = styled.div`
    width: 100%;
    height: 8px;
    background: var(--Neutral-neutral5, #F2F2F2);
`;